var map = {
	"./CERT(1).jpg": 960,
	"./CERT.jpg": 465,
	"./CERT02.jpg": 299,
	"./Cert 19.jpg": 355,
	"./GHS-1679-2024-024 (1)_page-0001.jpg": 583,
	"./cert 22.jpg": 217,
	"./cert 25.jpg": 730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;